export default class PrintedBillsController {
  constructor(ContentService, $state, moment, ProfilePermissionsService, $uibModal) {
    this.service = ContentService;
    this.state = $state;
    this.moment = moment;
    this.permissionsService = ProfilePermissionsService;
    this.modal = $uibModal;
  }

  $onInit(){
    this.subscriptions = [];

    this.reportParams = {
      date_to: undefined,
      date_from: undefined,
      amount: undefined,
      product: undefined
    }
    this.filterBy = {
      date: true,
      amount: false,
      product: false
    }
    this.rows = [];
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  
  findReport(){
    let date_to = this.reportParams.date_to ? this.reportParams.date_to.toISOString() : undefined;
    let date_from = this.reportParams.date_from ? this.reportParams.date_from.toISOString() : undefined;

    this.subscriptions.push(
      this.service.findPrintedBillsReport({
        date_to: this.filterBy.date ? date_to : undefined,
        date_from: this.filterBy.date ? date_from : undefined,
        amount: this.filterBy.amount ? this.reportParams.amount : undefined,
        product: this.filterBy ? this.reportParams.product : undefined
      }).subscribe(
        (data) => { this.rows = data.rows}
      )
    );
  }

  openBillDetails(invoiceId) {
    var that = this;
    if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')){
      this.modal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'invoice-details-template.html',
        appendClassName: 'ngdialog-theme-plain',
        controller: ($scope, $uibModalInstance, AccountInformationService) => {
          "ngInject";

          $scope.invoice = {};
          $scope.orders = [];
          $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();

          that.subscriptions.push(
            that.service.getInvoice(invoiceId).subscribe(
              (invoice) => $scope.invoice = invoice,
              (error) => console.log("Error while getting the invoice")
            )
          );

          that.subscriptions.push(
            AccountInformationService.getAccountInfo().subscribe(
              (resp) => {
                $scope.account = resp
              }
            )
          );

          $scope.getOrders = () => {
            if ($scope.orders.length <= 0) {
              that.subscriptions.push(
                that.service.getOrders(invoiceId).subscribe(
                  (orders) => $scope.orders = orders,
                  (error) => console.log("Error while getting the orders")
                )
              );
            }
          };
          $scope.fetchDetails = (order) => {
            if (!order.details || order.details.length <= 0) {
              that.subscriptions.push(
                that.service.getOrderDetails(invoiceId, order.id).subscribe(
                  (details) => {
                    order.details = details;
                    $scope.displayingOrder = order;
                  },
                  (error) => console.log("Error while getting the details for this order")
                )
              );
            }
          };

          $scope.printToCart = (printSectionId) => {
            var innerContents = document.getElementById(printSectionId).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            const styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();            
            const styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
            popupWinindow.document.write(`<html><head><title>Imprimir factura #${$scope.invoice.number}</title><style>${styleprint.innerHTML}</style><style>${styleprintBootstrap.innerHTML}</style></head><body onload="window.print()">${innerContents}</html>`);
            popupWinindow.document.close();
          };

          $scope.closeThisDialog = () => $uibModalInstance.close();
        }
      });
    }
  }

}

 PrintedBillsController.$inject = ['ContentService', '$state', 'moment', 'ProfilePermissionsService', '$uibModal'];



// WEBPACK FOOTER //
// ./src/app/pages/printed-bills/printed-bills.controller.js